/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_ReleasedInputs */

const en_status_released = /** @type {(inputs: Status_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Released`)
};

const es_status_released = /** @type {(inputs: Status_ReleasedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liberado`)
};

/**
* | output |
* | --- |
* | "Released" |
*
* @param {Status_ReleasedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_released = /** @type {((inputs?: Status_ReleasedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_ReleasedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_released(inputs)
	return es_status_released(inputs)
});